import { useState } from "react";

const INTERESTS = ["恋综 / 剧组", "综艺 / 选秀", "职场 / 生活", "数码 / 科技"];

const FORM_URL = "https://readdy.ai/api/form/dagmu13ep053ijub2e90";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // 反垃圾：蜜罐字段非空则静默当作成功返回，不向平台提交
    const honeypot = String(data.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，感谢关注每日有瓜！");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    form.querySelectorAll<HTMLInputElement>("input[name], textarea[name]").forEach((el) => {
      if (el.name === "website_alt") return;
      const val = el.value.trim();
      if (!val) return;
      if (el.type === "checkbox") {
        if (el.checked) payload.append(el.name, val);
      } else {
        payload.append(el.name, val);
      }
    });

    setStatus("idle");
    setMessage("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const code = parsed?.code || "";
      if (res.ok && code === "OK") {
        setStatus("success");
        setMessage("订阅成功，每日瓜报将准时送到你的邮箱！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg && serverMsg !== "OK" ? serverMsg : "订阅失败，请稍后再试或更换邮箱。");
      }
    } catch {
      setStatus("error");
      setMessage("网络开小差了，请稍后重试。");
    }
  }

  return (
    <section id="subscribe" className="py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-primary-600 px-6 py-10 md:px-12">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-500/60 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-accent-500/30 blur-2xl"></div>
          <div className="relative grid items-center gap-8 lg:grid-cols-2">
            <div>
              <p className="inline-flex items-center gap-2 rounded-full bg-primary-500/60 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-mail-send-line"></i>每日瓜报
              </p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                订阅每日瓜报，不错过任何一口热乎瓜
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-primary-50 md:text-base">
                把当天最热的话题、讨论区和评论区精华整理成摘要，准时送到你的邮箱。想退订，一键就能取消。
              </p>
            </div>

            <form onSubmit={handleSubmit} data-readdy-form className="rounded-xl bg-background-50 p-6 shadow-sm" aria-label="订阅每日瓜报">
              <label className="block text-sm font-medium text-foreground-800" htmlFor="gua-email">
                你的邮箱
              </label>
              <input
                id="gua-email"
                name="email"
                type="email"
                required
                autoComplete="email"
                placeholder="例如 name@example.com"
                className="mt-2 w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />

              <fieldset className="mt-4">
                <legend className="text-sm font-medium text-foreground-800">感兴趣的分类（可多选）</legend>
                <div className="mt-2 flex flex-wrap gap-2">
                  {INTERESTS.map((it) => (
                    <label key={it} className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition hover:border-primary-300 has-[:checked]:border-primary-400 has-[:checked]:bg-primary-50 has-[:checked]:text-primary-700">
                      <input type="checkbox" name="interest" value={it} className="h-3.5 w-3.5 accent-primary-600" />
                      {it}
                    </label>
                  ))}
                </div>
              </fieldset>

              <input type="text" name="website_alt" autoComplete="off" tabIndex={-1} aria-hidden="true" readOnly className="web-note-holder" />

              <button
                type="submit"
                disabled={status === "idle" && message !== ""}
                className="mt-5 w-full whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 disabled:opacity-60"
              >
                {status === "success" ? "✓ 已订阅" : "立即订阅瓜报"}
              </button>

              {status === "success" && (
                <p className="mt-3 flex items-start gap-1.5 rounded-md bg-secondary-100 px-3 py-2 text-xs text-secondary-900">
                  <i className="ri-checkbox-circle-line mt-0.5"></i>
                  {message}
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 flex items-start gap-1.5 rounded-md bg-primary-50 px-3 py-2 text-xs text-primary-800">
                  <i className="ri-error-warning-line mt-0.5"></i>
                  {message}
                </p>
              )}
              <p className="mt-3 text-xs text-foreground-400">提交即表示同意接收每日瓜报，我们不会向第三方共享你的信息。</p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}